import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthorizationErrors } from "src/components/Contexts/AuthorizationErrorsContext";

export const useUnauthorizedRedirect = () => {
  const { authorizationErrors } = useAuthorizationErrors();
  const navigate = useNavigate();

  useEffect(() => {
    if (authorizationErrors.size) {
      navigate("/unauthorized");
    }
  }, [authorizationErrors, navigate]);
};

export default useUnauthorizedRedirect;
